import React from "react";

const NotificationsList = () => {
  // Added more mock data as requested
  const notifications = [
    {
      id: 1,
      title: "Cash Vault Approved",
      message: "Your cash vault request has been approved.",
      timestamp: "26/02/2026 17:24:01",
    },
    {
      id: 2,
      title: "Transaction Failed",
      message: "The transaction ID 100006542 failed due to insufficient funds.",
      timestamp: "26/02/2026 15:10:45",
    },
    {
      id: 3,
      title: "New Transaction Received",
      message: "You have received a new transaction from SparkMinds JSC.",
      timestamp: "25/02/2026 09:30:12",
    },
    {
      id: 4,
      title: "System Maintenance",
      message:
        "Scheduled maintenance will occur on 28/02/2026 from 00:00 to 04:00.",
      timestamp: "24/02/2026 11:00:00",
    },
    {
      id: 5,
      title: "Refund Processed",
      message:
        "The refund for transaction 100005322 has been successfully processed.",
      timestamp: "23/02/2026 14:45:00",
    },
    {
      id: 6,
      title: "AML Check Pending",
      message: "Transaction 100006551 requires additional AML verification.",
      timestamp: "22/02/2026 10:15:30",
    },
  ];

  return (
    <div className="container-fluid">
      <div className="mb-4">
        <h2 className="fw-bold text-black mb-0 fs-24">Notifications</h2>
      </div>

      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="p-4 bg-light" style={{ minHeight: "60vh" }}>
          {notifications.map((notification) => (
            <div
              key={notification.id}
              className="bg-white border p-3 mb-1 d-flex flex-column"
              style={{
                borderColor: "#eaecf0",
                gap: "6px",
                borderRadius: "12px",
              }}
            >
              <div className="fw-bold text-black fs-14">
                {notification.title}
              </div>
              <div className="text-dark fs-13">{notification.message}</div>
              <div className="text-muted fs-11 mt-2">
                {notification.timestamp}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotificationsList;
